import React, { useState } from 'react';
import {
  Autocomplete,
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import { ProgramDto } from '../../../api/types/dtos/program';
import CreateProgramModal from '../modals/CreateProgramModal';

interface ProgramSelectorProps {
  programs: ProgramDto[];
  selectedProgram: ProgramDto | null;
  onSelect: (program: ProgramDto | null) => void;
  loading?: boolean;
}

const ProgramSelector: React.FC<ProgramSelectorProps> = ({
  programs,
  selectedProgram,
  onSelect,
  loading = false,
}) => {
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const handleCreateSuccess = (programId: string) => {
    // Find the newly created program and select it
    const newProgram = programs.find((p) => p.id === programId);
    if (newProgram) {
      onSelect(newProgram);
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', mb: 3 }}>
      <Box sx={{ flex: 1 }}>
        <Autocomplete
          value={selectedProgram}
          onChange={(_, newValue) => onSelect(newValue)}
          options={programs}
          getOptionLabel={(option) => option.name}
          renderOption={(props, option) => (
            <li {...props}>
              <Box>
                <Typography variant="body1">{option.name}</Typography>
                {option.description && (
                  <Typography variant="caption" color="text.secondary">
                    {option.description}
                  </Typography>
                )}
              </Box>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Seleccionar Programa"
              placeholder="Buscar programa..."
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading && <CircularProgress color="inherit" size={20} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          loading={loading}
          fullWidth
        />
      </Box>
      <Button
        variant="contained"
        startIcon={<Add />}
        onClick={() => setCreateModalOpen(true)}
        sx={{ minWidth: 'auto', px: 3, py: 1.8 }}
      >
        Nuevo
      </Button>
      <CreateProgramModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSuccess={handleCreateSuccess}
      />
    </Box>
  );
};

export default ProgramSelector;

